export default function PricingSection() {
  return (
    <section id="plans" className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-20 space-y-4 sm:space-y-6">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">料金プラン詳細</h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#757575] max-w-3xl mx-auto">
            それぞれのプランの詳しい内容をご確認ください
          </p>
        </div>
        <div className="space-y-8 sm:space-y-12 max-w-5xl mx-auto">
          {/* お試しサポートプラン */}
          <div className="bg-gradient-to-br from-[#F5F5DC] to-[#FAF0E6] rounded-3xl p-6 sm:p-10 lg:p-12">
            <div className="space-y-6 sm:space-y-8">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#2C2C2C] mb-2 sm:mb-3">
                    お試しサポートプラン
                  </h3>
                  <p className="text-base sm:text-lg text-[#757575]">まずは試してみたい方に</p>
                </div>
                <div className="text-left sm:text-right">
                  <div className="text-3xl sm:text-4xl font-bold text-[#66BB6A]">¥3,900</div>
                  <div className="text-sm sm:text-base text-[#757575]">(税込)</div>
                </div>
              </div>
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">このような方にお勧めです</h4>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-user-smile-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        できる限り自分たちで挑戦したいが、困ったときだけ相談したい
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-user-smile-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">ピンポイントで聴きたい箇所がある（Instagramの投稿の方法のみ知りたいなど）</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">サポート内容</h4>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        月3時間までの対面またはオンライン相談
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        SNSなどの投稿計画サポート
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">習得したいツールのサポート</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">CanvaやAIの基本レッスン</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">オーナー様向け共有レポート</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-information-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-xs sm:text-sm text-[#757575]">※その他ご希望の内容により計画提案させていただきます。</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">料金内訳</h4>
                  <div className="bg-white/60 rounded-2xl p-4 sm:p-6">
                    <p className="text-sm sm:text-base text-[#2C2C2C] mb-2 sm:mb-3">
                      3時間 × 1,300円 = 3,900円
                    </p>
                    <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-[#757575]">
                      <li>• オーナー向け共有レポート(無料)</li>
                      <li>• スタッフ向け振り返り資料(無料)</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">メリット</h4>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-star-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">低価格で開始しやすい</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        月1回の相談でモチベーション維持と方向修正ができる
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* 安心コミットプラン */}
          <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-3xl p-6 sm:p-10 lg:p-12 border-2 border-[#66BB6A]">
            <div className="space-y-6 sm:space-y-8">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                  <div className="inline-block bg-[#66BB6A] text-white px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-bold mb-3 sm:mb-4">
                    人気No.1
                  </div>
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#2C2C2C] mb-2 sm:mb-3">
                    安心コミットプラン
                  </h3>
                  <p className="text-base sm:text-lg text-[#2C2C2C]">しっかりサポートを受けたい方に</p>
                </div>
                <div className="text-left sm:text-right">
                  <div className="text-3xl sm:text-4xl font-bold text-[#66BB6A]">¥5,800</div>
                  <div className="text-sm sm:text-base text-[#2C2C2C]">/ 月(税込)</div>
                </div>
              </div>
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">このような方にお勧めです</h4>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-user-heart-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">スタッフさんが2人以上の場合</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-user-heart-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">相談時間外でもすぐに聞ける人が欲しい</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-user-heart-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">より早く成果につながる運用をしたい</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">サポート内容</h4>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        月3時間までの対面またはオンライン相談
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        SNSなどの投稿計画サポート(ネタ出し、計画)
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        習得したいツールのサポート
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        CanvaやAIの基本 および応用レッスン
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        オーナー様向け共有レポート
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-information-line text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-xs sm:text-sm text-[#757575]">※その他ご希望の内容により計画提案させていただきます</span>
                    </li>
                  </ul>
                  <div className="bg-white/60 rounded-2xl p-4 sm:p-6 mt-3 sm:mt-4">
                    <div className="flex items-center gap-2 mb-2 sm:mb-3">
                      <i className="ri-chat-smile-3-fill text-xl sm:text-2xl text-[#EF5350]"></i>
                      <p className="text-sm sm:text-base text-[#EF5350] font-bold">
                        LINE(チャット)質問し放題(月〜金)
                      </p>
                    </div>
                    <p className="text-sm sm:text-base text-[#2C2C2C] mb-2 sm:mb-3">例えば...</p>
                    <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-[#2C2C2C]">
                      <li>• どの写真が良い?</li>
                      <li>• ハッシュタグは合ってる?</li>
                      <li>• 急なお知らせの文章を考えたい</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">料金内訳</h4>
                  <div className="bg-white/60 rounded-2xl p-4 sm:p-6">
                    <p className="text-sm sm:text-base text-[#2C2C2C] mb-2 sm:mb-3">
                      相談3時間(3,900円)+ チャットサポート
                    </p>
                    <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-[#757575]">
                      <li>• オーナー向け共有レポート(無料)</li>
                      <li>• スタッフ向け振り返り資料(無料)</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">メリット</h4>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        疑問をすぐ解決できるため、作業が止まらない
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-star-fill text-lg sm:text-xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                      <span className="text-sm sm:text-base text-[#2C2C2C]">
                        精神的な安心が大きく、運用の質が上がる
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
